/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Rozszerzenia/modyfikacje komponentów Boostrap
 *
 * @class DropdownExtension
 */
export class DropdownExtension {
	constructor(options) {
		var defaults = {
			selector: '.dropdownCustom'
		};
		this.dropdownSettings = $.extend({}, defaults, options);
	}
	// ****************************************************************************************************
	// Inicjalizacja Dropdowns
	// ****************************************************************************************************
	initDropdowns(options) {
		var that = this;
		var opt = $.extend({}, that.dropdownSettings, options);
		var dropdowns = $(opt.selector);
		dropdowns.each(function (i, e) {
			var dropdownShown = false;
			var dropDownTimer;
			var btn = $(e);
			var parent = $(e).parent('div');
			parent.on('show.bs.dropdown', function () {
				dropdownShown = true;
			}).on('hide.bs.dropdown', function () {
				dropdownShown = false;
			}).on('mouseenter', function () {
				clearTimeout(dropDownTimer);
			}).on('mouseleave', function () {
				if (pageObj.settings.bootstrap.kind != 'mobile')
					dropDownTimer = setTimeout(function () {
						if (dropdownShown) {
							btn.dropdown('toggle');
							dropdownShown = false;
						}
					}, POPOVER_LIFE_TIME);
			});
		});
	}
}